import type { CityConfig } from "../city-template/types";

export const kennewickConfig: CityConfig = {
  city: "Kennewick",
  state: "Washington",
  stateAbbr: "WA",
  slug: "kennewick",
  route: "/kennewick",
  title: "Emergency Passport Kennewick WA | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Kennewick, Washington — as fast as 24 hours. Fast passport renewal and new passport applications for Kennewick, Pasco, Richland, and all Tri-Cities residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Kennewick, WA",
  heroSubtitle: "Kennewick travelers — from Tri-Cities wine country professionals to Columbia River families to Hanford site engineers — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of the Tri-Cities and southeastern Washington.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Kennewick%20Washington%20along%20the%20Columbia%20River%20with%20the%20Blue%20Bridge%20and%20Cable%20Bridge%20spanning%20the%20water%2C%20Tri-Cities%20skyline%20with%20Pasco%20and%20Richland%20visible%20across%20the%20river%2C%20Columbia%20River%20waterfront%20parks%20and%20marina%2C%20vineyards%20and%20rolling%20hills%20in%20the%20background%2C%20sunny%20high%20desert%20climate%20with%20dramatic%20clouds%2C%20warm%20golden%20afternoon%20light%20over%20the%20Columbia%20Basin%2C%20professional%20city%20photography%20without%20text%20or%20people&width=1800&height=700&seq=kennewick-hero-001&orientation=landscape",
  heroImageAlt: "Kennewick Washington Columbia River waterfront with Tri-Cities bridges",
  geoPosition: "46.2117;-119.1711",
  geoPlacename: "Kennewick, Washington",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle WA 98174",
    distance: "Approximately 220 miles northwest of Kennewick via I-82/I-90",
  },
  nearbyCitiesZips: [
    { name: "Kennewick", zips: "99336, 99337, 99338" },
    { name: "Pasco", zips: "99301, 99302" },
    { name: "Richland", zips: "99352, 99353, 99354" },
    { name: "West Richland", zips: "99353" },
    { name: "Benton City", zips: "99320" },
    { name: "Prosser", zips: "99350" },
    { name: "Finley", zips: "99336" },
    { name: "Burbank", zips: "99323" },
    { name: "Connell", zips: "99326" },
    { name: "Basin City", zips: "99343" },
    { name: "Othello", zips: "99344" },
    { name: "Walla Walla", zips: "99362" },
    { name: "College Place", zips: "99324" },
    { name: "Hermiston (OR)", zips: "97838" },
    { name: "Umatilla (OR)", zips: "97882" },
    { name: "Pendleton (OR)", zips: "97801" },
    { name: "Sunnyside", zips: "98944" },
    { name: "Grandview", zips: "98930" },
    { name: "Yakima", zips: "98901, 98902, 98903, 98904, 98908" },
    { name: "The Dalles (OR)", zips: "97058" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Seattle Passport Agency — cross-state courier service from the Tri-Cities" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Eastern Washington" },
    { icon: "ri-landscape-line", title: "Tri-Cities & Columbia Basin Hub", desc: "Serving Kennewick, Pasco, Richland, Hanford, and all of southeastern Washington" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any Tri-Cities location" },
  ],
  internalLinks: [
    { name: "Expedited passport in Spokane, WA", route: "/spokane" },
    { name: "Urgent passport services in Yakima, WA", route: "/yakima" },
    { name: "Washington passport services overview", route: "/washington" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Kennewick, Washington remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (915 2nd Ave Suite 500, Seattle WA 98174) — approximately 3.5 hours northwest via I-82 and I-90. Kennewick residents can ship from any UPS or FedEx in the Tri-Cities.",
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  fpcOfficeDistance: "Serving Kennewick, Pasco, Richland, West Richland, Benton City, Finley, and all of the Tri-Cities and southeastern Washington",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Kennewick and the Tri-Cities. From the Columbia River waterfront and the historic downtown to the Southridge area and the wine country that makes the Tri-Cities famous, from the Hanford site and PNNL to the families, agricultural workers, and professionals of southeastern Washington — we serve all of Kennewick and the greater Tri-Cities region.",
  nearbyCitiesIntro: "We serve Kennewick and all nearby communities including Pasco, Richland, West Richland, Benton City, Prosser, Finley, Burbank, and Connell. We also serve Walla Walla, Hermiston OR, Pendleton OR, Yakima, Sunnyside, and the entire Columbia Basin region.",
  howItWorksIntro: "Most Kennewick travelers complete everything online and ship documents overnight. The Tri-Cities is 3.5 hours from Seattle — our couriers handle the cross-state delivery so you never need to make that drive yourself.",
  mistakesIntro: "Kennewick is the largest city in the Tri-Cities and a major hub for the Columbia Basin — home to Hanford, PNNL, and a booming wine industry. Here are the most common passport mistakes we see from Tri-Cities travelers.",
  testimonialsIntro: "Kennewick travelers — from Hanford engineers to wine industry professionals to Tri-Cities families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Kennewick, WA? Here are the most common ones we hear from Tri-Cities travelers.",
  statePageRoute: "/states/washington",
  statePageName: "Washington",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (WA DOH)", url: "https://doh.wa.gov/licenses-permits-and-certificates/vital-records", desc: "Washington State Department of Health — Center for Health Statistics for birth and death certificates statewide" },
    { label: "Marriage Licenses (Benton County Auditor)", url: "https://www.bentoncountywa.gov/", desc: "Benton County Auditor — marriage license applications and certified copies for Kennewick and Tri-Cities" },
    { label: "Divorce Decrees (Benton County Superior Court)", url: "https://www.bentoncountywa.gov/", desc: "Benton County Superior Court — divorce decree records for Kennewick and Tri-Cities residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Washington birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  dmvWebsite: "https://www.dol.wa.gov",
  dmvLabel: "Washington DOL — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — cross-state courier service", "No 3.5-hour drive across Washington", "Perfect for Hanford and wine industry travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — cross-state courier", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 3.5 hours across the state to Seattle", "Requires full day off work and overnight stay"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Kennewick travelers with immediate departure needs — as fast as 24 hours. Our couriers handle the Seattle agency delivery. Perfect for Hanford business travel, wine industry conferences, and Tri-Cities family emergencies.",
      bullets: ["24–48 hour turnaround available", "Seattle Passport Agency — cross-state courier", "Hanford, PNNL, and wine industry travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Kennewick adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Tri-Cities address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Kennewick residents and families — including Hanford engineers, wine industry professionals, and Tri-Cities residents.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Kennewick residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Kennewick and Tri-Cities families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Kennewick and Tri-Cities residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Kennewick WA", description: "Urgent passport processing for Kennewick Washington travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Kennewick WA", description: "Fast passport renewal for Kennewick Washington residents with a previously-issued passport." },
    { name: "First-Time Passport Kennewick WA", description: "New passport application services for Kennewick Washington residents applying for their first passport." },
    { name: "Child Passport Kennewick WA", description: "Minor passport services for Kennewick Washington families with children under 16." },
  ],
  testimonials: [
    {
      name: "Mark T.",
      location: "Kennewick, WA",
      rating: 5,
      text: "Hanford conference in Vienna with 6 days notice and my passport was expired. Fast Passport Center had my renewed passport in 2 days. I shipped from the UPS Store on Columbia Center Blvd. Not having to drive 3.5 hours to Seattle was a lifesaver.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Jennifer & Rob S.",
      location: "Richland, WA",
      rating: 5,
      text: "Family trip to Italy with 10 days notice. Three passports — one adult renewal and two first-time for our kids. Done in 5 days. We shipped from FedEx in Kennewick. Outstanding service for the Tri-Cities.",
      service: "Family Passport Bundle",
    },
    {
      name: "David L.",
      location: "Pasco, WA",
      rating: 5,
      text: "Wine business trip to France with 8 days notice. Fast Passport Center walked me through everything and had my passport in 3 days. Living in the Tri-Cities means no passport agency for hundreds of miles — this courier service is essential.",
      service: "Emergency Passport",
    },
    {
      name: "Rachel W.",
      location: "West Richland, WA",
      rating: 5,
      text: "Lost my passport three weeks before a family reunion in Mexico. Fast Passport Center replaced it in 4 days. The courier service is an absolute must for anyone living in Eastern Washington.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "ken-1",
      name: "Kennewick Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "525 S Auburn St",
      city: "Kennewick",
      state: "WA",
      zip: "99336",
      phone: "(509) 582-4005",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Kennewick, near the Columbia River waterfront",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Kennewick acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown Kennewick and the Tri-Cities business district.",
      icon: "ri-mail-line",
    },
    {
      id: "ken-2",
      name: "Pasco Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3500 W Court St",
      city: "Pasco",
      state: "WA",
      zip: "99301",
      phone: "(509) 547-2402",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Pasco, approximately 5 miles east of downtown Kennewick",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Pasco, Burbank, and east Tri-Cities residents. Ample parking available near the Tri-Cities Airport (PSC).",
      icon: "ri-mail-line",
    },
    {
      id: "ken-3",
      name: "Richland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "738 The Parkway",
      city: "Richland",
      state: "WA",
      zip: "99352",
      phone: "(509) 943-5518",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Richland, approximately 7 miles northwest of downtown Kennewick",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Richland, West Richland, and Hanford area. Good alternative for north Tri-Cities residents near PNNL.",
      icon: "ri-mail-line",
    },
    {
      id: "ken-4",
      name: "Prosser Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1103 Meade Ave",
      city: "Prosser",
      state: "WA",
      zip: "99350",
      phone: "(509) 786-3179",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Prosser, approximately 30 miles west of Kennewick",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Prosser, Benton City, and western Benton County communities. Good alternative for wine country residents.",
      icon: "ri-mail-line",
    },
    {
      id: "ken-5",
      name: "Benton County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "7122 W Okanogan Pl, Building A",
      city: "Kennewick",
      state: "WA",
      zip: "99336",
      phone: "(509) 736-3071",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Kennewick Benton County Justice Center",
      website: "https://www.bentoncountywa.gov/",
      websiteLabel: "Benton County",
      notes: "Benton County Clerk passport acceptance. Extended hours compared to post office. Convenient to Kennewick. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3.5-hour drive to Seattle across the state", fpc: "No — ship from Kennewick" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Eastern WA Advantage", agency: "No special guidance", fpc: "Yes — Tri-Cities and Columbia Basin expertise" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Kennewick Hanford workers and wine industry professionals often discover passport issues just before international conferences. Routine processing takes 6–13 weeks. For Tri-Cities residents 220 miles from the nearest passport agency, start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services on Columbia Center Blvd or at Columbia Center Mall sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Benton County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Kennewick and Richland Post Office appointments fill during summer family travel peaks. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "The Geography Gap — 220 Miles from Seattle",
      description: "Many Tri-Cities residents underestimate the distance to the nearest passport agency. Seattle is 3.5 hours away — a full-day round trip plus Seattle traffic and parking. Never attempt an emergency drive across the state — use our courier service instead.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. Wine industry travel to Europe and Hanford international conferences both create steady demand in the Tri-Cities — plan ahead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Kennewick area or Tri-Cities." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Kennewick, Pasco, or Richland." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Seattle Passport Agency — no need to drive 3.5 hours across Washington yourself." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Kennewick address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Kennewick, WA?", a: "Fast Passport Center offers emergency passport processing in Kennewick, Washington in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (915 2nd Ave Suite 500, Seattle WA 98174) — approximately 220 miles northwest, but our courier service handles the cross-state delivery for you." },
    { q: "Is there a passport agency near the Tri-Cities?", a: "No — the Tri-Cities region does not have a regional passport agency. The nearest facility is the Seattle Passport Agency (approximately 3.5 hours northwest via I-82/I-90). This is one of the longest distances to a passport agency in Washington State. Fast Passport Center's courier service is the solution for Tri-Cities residents." },
    { q: "Can I get an expedited passport in Pasco, Richland, or West Richland?", a: "Absolutely. Fast Passport Center serves all of the Tri-Cities including Pasco, Richland, West Richland, and all surrounding communities in Benton and Franklin counties. Our service works the same way everywhere." },
    { q: "What airport do Kennewick travelers use for international flights?", a: "Tri-Cities Airport (PSC) in Pasco offers flights via Alaska Airlines, Delta, United, and Allegiant with connections through Seattle, Salt Lake City, Denver, and other hubs. For international travel, most Tri-Cities residents connect through Seattle-Tacoma International Airport (SEA). PSC is conveniently located just 10 minutes from Kennewick." },
    { q: "Does Fast Passport Center serve Hanford site and PNNL employees?", a: "Yes. Fast Passport Center serves all of the Tri-Cities including Hanford site workers and Pacific Northwest National Laboratory (PNNL) scientists. We understand the unique travel needs of the DOE and research community, and can accommodate urgent international assignments." },
    { q: "How much does an expedited passport cost in Kennewick, WA?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Kennewick?", a: "Walgreens, CVS, and Rite Aid stores throughout the Tri-Cities offer passport photos. UPS Store and FedEx Office locations also provide them. Locations on Columbia Center Blvd and at Columbia Center Mall offer walk-in service. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Are there any passport agencies closer than Seattle for Tri-Cities residents?", a: "Technically, the Portland Passport Agency in Oregon is also an option, but there is no passport agency in Portland — this is a common misconception. The closest and only passport agency is in Seattle, 220 miles away. Fast Passport Center's courier service eliminates the need to travel to Seattle entirely." },
  ],
  photoLocations: [
    { name: "Walgreens — Columbia Center Blvd", address: "2615 W Kennewick Ave, Kennewick, WA 99336", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Rite Aid — Clearwater Ave", address: "1320 N Louisiana St, Kennewick, WA 99336", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — Gage Blvd", address: "3315 W Clearwater Ave, Kennewick, WA 99336", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Richland", address: "2607 Queensgate Dr, Richland, WA 99352", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "WA DOL — Kennewick", address: "2801 S 10th Ave, Kennewick, WA 99337", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Washington Department of Licensing for driver's licenses, REAL ID, and vehicle registration. Online appointments strongly recommended.", featured: true },
    { name: "WA DOL — Richland", address: "1445 Spaulding Ave, Richland, WA 99352", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Serves Richland and north Kennewick. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "PSC",
      name: "Tri-Cities Airport",
      distance: "10 minutes from downtown Kennewick",
      address: "3601 N 20th Ave, Pasco, WA 99301",
      note: "Primary airport for Kennewick and the Tri-Cities. Alaska Airlines, Delta, United, and Allegiant serve PSC with flights connecting through Seattle, Salt Lake City, Denver, Minneapolis, and other major hubs. Free parking and short security lines make PSC a breeze.",
      flightUrl: "https://www.flytricities.com/",
      flightLabel: "PSC Flight Info",
      featured: true,
    },
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "3.5 hours northwest of Kennewick via I-82/I-90",
      address: "17801 International Blvd, Seattle, WA 98158",
      note: "Major international gateway. Most Tri-Cities travelers connect through SEA via PSC. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines hub.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA Flight Info",
      featured: false,
    },
    {
      code: "PDX",
      name: "Portland International Airport (OR)",
      distance: "Approximately 3 hours southwest of Kennewick via I-84",
      address: "7000 NE Airport Way, Portland, OR 97218",
      note: "Alternative international airport for Tri-Cities residents. Drive time similar to Seattle but on I-84 instead of I-82/I-90. International flights to Asia and Europe available.",
      flightUrl: "https://www.flypdx.com/",
      flightLabel: "PDX Flight Info",
      featured: false,
    },
  ],
};